import { render, staticRenderFns } from "./IconShare.vue?vue&type=template&id=44cd0116&"
var script = {}
import style0 from "./IconShare.vue?vue&type=style&index=0&id=44cd0116&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports